module.exports = __webpack_public_path__ + "img/liberia.f3031914.svg";